export enum FleetActionNames {
  LOAD_FLEET_LOGO_URL_REQUEST = 'LOAD_FLEET_LOGO_URL_REQUEST',
  LOAD_FLEET_LOGO_URL_SUCCEEDED = 'LOAD_FLEET_LOGO_URL_SUCCEEDED',
  LOAD_FLEET_LOGO_URL_FAILED = 'LOAD_FLEET_LOGO_URL_FAILED',
  ERROR_ALERT_FLEET_LOGO = 'ERROR_ALERT_FLEET_LOGO',
  UPLOAD_FLEET_LOGO = 'UPLOAD_FLEET_LOGO',
  DELETE_FLEET_LOGO_REQUEST = 'DELETE_FLEET_LOGO_REQUEST',
}

export type LoadFleetLogoUrlRequest = {
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_REQUEST;
  payload: string;
};

export type LoadFleetLogoUrlSucceeded = {
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_SUCCEEDED;
  payload: string | null;
};
export type DeleteFleetLogoRequest = {
  type: FleetActionNames.DELETE_FLEET_LOGO_REQUEST;
};

export type LoadFleetLogoUrlError = {
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_FAILED;
};

export type UploadFleetLogo = {
  type: FleetActionNames.UPLOAD_FLEET_LOGO;
  payload: Blob;
};

export type AlertErrorUpload = {
  type: FleetActionNames.ERROR_ALERT_FLEET_LOGO;
  payload: Error;
};

export type FleetAction = LoadFleetLogoUrlRequest | LoadFleetLogoUrlSucceeded | LoadFleetLogoUrlError;
